/**
 * `/customer/*` routes v2 calls (API_ACCESS.md §3.1), held to the snapshot by `api/routes.test.ts`.
 */
import { gated } from "../../capabilities/access";
import { defineRoutes, route } from "../route";

export const CUSTOMER = defineRoutes("customer", {
  save: route<Record<string, unknown>, Record<string, unknown>>(
    "POST",
    "/customer/save",
    gated({ modules: ["Sale", "Order", "Marketing", "Settings", "Support", "Schedule", "Kiosk"] }),
    { notes: "creates or updates a customer and answers the saved record (`mid` is its ref); the kiosk's customer lookup (`ordering/customer`'s `attachSearchedCustomerToSale`) creates one from a number alone when the search finds none, and saves a found customer's fetched record back, without `loyaltyInfo` and `providerConsents`" },
  ),
  authenticate: route<{ branchId?: string; customerRefId?: string }, Record<string, unknown>>(
    "POST",
    "/customer/authenticate",
    gated({ modules: ["Sale", "Order", "Delivery", "Support", "Schedule", "Kiosk"] }),
    { notes: "sends the customer an OTP and answers its hash; the discount module's customer check (`discounts/hooks/useCustomerAuthentication`)" },
  ),
  consentOtp: route<Record<string, unknown>, Record<string, unknown>>("POST", "/customer/consent-otp", gated({ modules: ["Sale", "Order"] }), {
    notes:
      "sends the customer the programme's consent OTP, or says they already consented: reads `phoneNumber` and `providerId` alone (`metaId` and `customerInfo` are never read); answers `{ status, message, otpSent, isNewEnrollment }` (customer_controller.js:2067-2096; sale_customer_service.js:678-731; points-conversations.md §1)",
  }),
  consentOtpVerify: route<Record<string, unknown>, Record<string, unknown>>("POST", "/customer/consent-otp/verify", gated({ modules: ["Sale", "Order"] }), {
    notes:
      "checks the consent OTP and enrols the customer: needs `phoneNumber`, `providerId`, `otp` and `customerInfo` with `contactInfo.name.firstName`; answers `{ status, message, data }` (customer_controller.js:2097-2134; sale_customer_service.js:733-775)",
  }),
  optOut: route<Record<string, unknown>, Record<string, unknown>>("POST", "/customer/optout", gated({ modules: ["Sale"] }), {
    notes:
      "withdraws the customer from the loyalty programme of the branch's FIRST loyalty provider, whatever partner the caller means; only DotPe implements it, and every other partner answers an empty success (customer_controller.js:564-617; api_service.js:780-785; points-conversations.md F9)",
  }),
});
